import { render, staticRenderFns } from "./SeriesCheckboxSection.vue?vue&type=template&id=b5a27ef0&scoped=true&"
import script from "./SeriesCheckboxSection.vue?vue&type=script&lang=js&"
export * from "./SeriesCheckboxSection.vue?vue&type=script&lang=js&"
import style0 from "./SeriesCheckboxSection.vue?vue&type=style&index=0&id=b5a27ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a27ef0",
  null
  
)

export default component.exports